(function($) { $(document).ready(function() {


    var $warp_fragment_refresh = {

        url: woocommerce_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
        type: 'POST',
        success: function( data ) {

            if ( data && data.fragments ) {
                console.log(data, data.fragments);
                $.each( data.fragments, function( key, value ) {
                    $( key ).replaceWith( value );
                });

                $('.side-cart').addClass('opened');
                $('.site-header').addClass('menu-opened');

                $('html').css('marginTop', window.scrollY * (-1) );
                $('body').css({'width' : window_width, height : window_height }).addClass('side-cart-opened');

                $( document.body ).trigger( 'wc_fragments_refreshed' );
            }
        }
    };



    /**
     * Add to cart button
     */
    $('.add-to-cart-ajax').on('click', function (e){

        let $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            content = $('.side-cart__content');

        let data = {
            product_id: $(this).attr('data-product-id')
        };

        e.preventDefault();

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        $.ajax({
            type: 'POST',
            url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('add-to-cart-ajax--added');
                $thisbutton.addClass('add-to-cart-ajax--loader');
                content.addClass('side-cart__content--loader');
            },
            complete: function (response) {
                $thisbutton.removeClass('add-to-cart-ajax--loader').addClass('add-to-cart-ajax--added');
            },
            success: function (response) {

                if (response.error && response.product_url) {
                    // alert('Error adding a product to the cart.');
                    window.location.href = response.product_url;
                    return;
                }

                setTimeout(function () {
                    $thisbutton.removeClass('add-to-cart-ajax--added');
                }, 1500);

                content.removeClass('side-cart__content--loader');

                $('.side-cart').addClass('opened');
                $('.site-header').addClass('menu-opened');

                $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

                $('.added_to_cart').hide();
            },
        });

        return false;
    });

    /**
     * Check if isset parametr added product
     */
    let searchParams = new URLSearchParams(window.location.search);
    if(searchParams.has('added_product')){
        $('.side-cart').addClass('opened');
    }

    // Cart counter function
    function toggle_cart_counter(type, number = 1){

        let cart_counter = $('.cart-counter');

        if(type == 'add'){
            cart_counter.html(Number(cart_counter.html()) + number);
        }else{
            cart_counter.html(Number(cart_counter.html()) - number);
        }

        if(Number(cart_counter.html()) == 0){
            cart_counter.addClass('hidden')
        }else{
            cart_counter.removeClass('hidden')
        }

    }

}); })( jQuery );